import * as Comlink from 'comlink';
import PythonWorker from './python.worker?worker';
type PythonApi={run(source:string):Promise<string>};let remote:Comlink.Remote<PythonApi>|undefined;export function runPython(source:string){if(!remote)remote=Comlink.wrap<PythonApi>(new PythonWorker());return remote.run(source);}
